var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v("Group Notifications")]),_c('TasksTable',{attrs:{"headers":_vm.headers,"queueMessage":_vm.Allnotifications},on:{"getUserTask":function($event){return _vm.getAllTasks()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }